import type { LedgerType } from '@libs/enums';
import { useCustomFieldSettings } from '../../../context';
import { CustomFieldBasicSettingProvider, CustomFieldLedgerSettingProvider } from '../models';
import type { CustomFieldBasicSetting, CustomFieldLedgerSettingDetail } from '../models';

export function useCustomFieldBasicSettings() {
  const { basicSetting } = useCustomFieldSettings();

  return CustomFieldBasicSettingProvider.fromSettings(basicSetting);
}

export function useCustomFieldLedgerSettings() {
  const { ledgerSetting } = useCustomFieldSettings();

  return CustomFieldLedgerSettingProvider.fromSettings(ledgerSetting);
}

interface CustomFieldSetting {
  customFieldKey: number;
  basicSetting: CustomFieldBasicSetting;
  ledgerSettingDetail: CustomFieldLedgerSettingDetail;
}

export function useCustomFieldSettingMap() {
  const { basicSetting, ledgerSetting } = useCustomFieldSettings();
  const basicSettingMap = new Map<number, CustomFieldBasicSetting>();
  basicSetting.forEach((bs) => basicSettingMap.set(bs.customFieldKey, bs));
  const result: Map<LedgerType, CustomFieldSetting[]> = new Map();
  ledgerSetting.forEach((ledgerSetting) =>
    result.set(
      ledgerSetting.ledger,
      ledgerSetting.detail
        .filter(
          (ledgerSettingDetail) =>
            ledgerSettingDetail.customField && !Number.isNaN(Number(ledgerSettingDetail.customField)),
        )
        .map((ledgerSettingDetail) => {
          const singleBasicSetting = basicSettingMap.get(Number(ledgerSettingDetail.customField))!;
          return {
            customFieldKey: singleBasicSetting.customFieldKey,
            basicSetting: singleBasicSetting,
            ledgerSettingDetail,
          };
        }),
    ),
  );
  return result;
}

export type { CustomFieldSetting };
